export default {
      id: "i-tbank-logo-usage",
      viewBox: "0 0 79 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-tbank-logo",
      toString: function () {
        return this.url;
      }
    }